import { render } from "./MovieExplorer.vue?vue&type=template&id=6fc63bb8"
import script from "./MovieExplorer.vue?vue&type=script&lang=js"
export * from "./MovieExplorer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__